import {WBCommonException} from './exception';

export class UnavailableException extends WBCommonException {
    public name = 'UnavailableException';

    constructor(public message: string, public description?: string) {
        super(message);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/exception/entity/unavailable.exception.ts